export const ROLES = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  BASIC: 'BASIC',
} as const;

export type Role = typeof ROLES[keyof typeof ROLES];
